import * as React from 'react';
import styled, { css } from 'styled-components';
export var ListRowVariant;
(function (ListRowVariant) {
    ListRowVariant["Default"] = "Default";
    ListRowVariant["Header"] = "Header";
    ListRowVariant["SubHeader"] = "SubHeader";
})(ListRowVariant || (ListRowVariant = {}));
const ContentWrapper = styled.div `
  display: flex;
  align-items: center;
  flex-grow: 1;
`;
const DecorationWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 16px;
`;
const IconWrapper = styled.div `
  padding-right: 8px;

  svg {
    --icon-size: 20px;
  }
`;
const ListRowWrapper = styled.div `
  display: flex;
  align-items: center;
  height: 48px;
  padding-right: 24px;
  padding-left: ${({ depth }) => Math.max(depth === undefined ? 0 : depth, 0) * 28 + 24}px;
  border-bottom: 1px solid ${({ theme }) => theme.gray.blendToBackground(150)};

  ${({ variant }) => (variant === undefined || variant === ListRowVariant.Default) &&
    css `
      background-color: ${({ theme }) => theme.background};
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
    `}

  ${({ variant }) => variant === ListRowVariant.Header &&
    css `
      background-color: ${({ theme }) => theme.background};
      color: ${({ theme }) => theme.secondary.blendToBackground(900)};
      font-size: 14px;
      font-weight: 400;
      line-height: 16px;
    `}

  ${({ variant }) => variant === ListRowVariant.SubHeader &&
    css `
      background-color: ${({ theme }) => theme.gray.blendToBackground(24)};
      font-size: 14px;
      font-weight: 500;
      line-height: 16px;
    `}
`;
export const ListRow = ({ content, depth, icon, rightDecoration, variant }) => {
    return (React.createElement(ListRowWrapper, { depth: depth, variant: variant },
        React.createElement(ContentWrapper, null,
            icon && React.createElement(IconWrapper, null, icon),
            content),
        rightDecoration && React.createElement(DecorationWrapper, null, rightDecoration)));
};
//# sourceMappingURL=ListRow.js.map